import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import UserAdminEditComponent from 'src/components/views/UserAdmin/UserAdminEditPage';
import { IStateDepartment, IStoreState } from 'src/entity/StateEntity';

const mapStateToProps = ({ userState: { isDomestic, isAgent }, departmentState }: IStoreState) => ({
  isDomestic,
  departmentState,
  isAgent,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateDepartment>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAdminEditComponent);



// WEBPACK FOOTER //
// ./src/containers/UserAdminEdit.ts